<template >
    <div class="chart-wrapper">
        <MainChartTabs @tabMutated="tabMutated" :defaultTab="defaultTab" />
        <MainChartTips
            class="top-title"
            v-show="showTip && titleData.length"
            :titleData="titleData"
            :isLikeMin1="isLikeMin1"
        />
        <div class="chart-section">
            <div class="left" :class="{ 'left-full': true }">
                <MainChartSubTips
                    v-show="!isLikeMin1"
                    :show="showTip"
                    class="sub-title"
                    :tick="subTitleData"
                />
                <img
                    class="icon"
                    src="../../../assets/icon-chart-logo.png"
                    alt=""
                />
                <div
                    class="main-chart-top"
                    @touchstart="touchStart($event, 'topChart')"
                    @touchmove="touchMove($event, 'topChart')"
                    @touchend="touchEnd($event, 'topChart')"
                    :class="{ 'top-full': !isLikeMin1 }"
                    id="main-chart-top"
                ></div>
                <MainChartIndicators
                    class="indicators"
                    v-show="!isLikeMin1"
                    @indicatorMutated="indicatorMutated"
                />
                <MainChartSubTips
                    :show="showTip"
                    tipType="bottom"
                    class="sub-title bottom-title"
                    :tick="bottomTitleData"
                />
                <div
                    class="main-chart-bottom"
                    @touchstart="touchStart($event, 'bottomChart')"
                    @touchmove="touchMove($event, 'bottomChart')"
                    @touchend="touchEnd($event, 'bottomChart')"
                    :class="{ 'bottom-full': !isLikeMin1 }"
                    id="main-chart-bottom"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from '@/api/request'
import echarts from 'echarts'
import MainChartTabs from './MainChartTabs'
import MainChartTips from './MainChartTips'
import MainChartSubTips from './MainChartSubTips'
import MainChartIndicators from './MainChartIndicators'
import { getKlineByHttp, getPlateTrendData, getPlateFiveTrendData, getPlateHistoryTrendData } from '@/api'
import { ws } from '@/websocket'
const last = require('lodash/last')
const unitUtils = require('@/utils/formatUnit')
import charts from '@/utils/chart/index'
import config from '@/utils/chart/config'

export default {
    props: {
        plateBasicInfo: {
            required: true,
            type: Object
        },
        prodCode: {
            required: true,
            type: String
        },
        statistic: {
            require: true,
            type: Object,
            default: () => { }
        },
        defaultTab: {
            type: String,
            default: 'MIN1'
        }
    },
    data() {
        return {
            MIN1Time: null,
            titleData: [
                // {title: '', value: '', className: ''}
            ],
            subTitleData: [
                // {title: 'MA5', value: 1.23, color: ''},
            ],
            bottomTitleData: [],
            showTip: false,
            tradingKlines: config.tradingKlines,
            klineType: this.defaultTab,
            techType: 'v',
            init: false,
            dataSet: {},
            klineDataInit: false,
            // if realKlineType is not null, klineType convert to realKlineType after handle data
            realKlineType: null,
            klineStack: [],
            pendingType: {},
            topOptions: {
                grid: {
                    top: 15,
                    left: 0,
                    bottom: 21,
                    right: 0
                }
            },
            timer: null
        }
    },
    computed: {
        isLikeMin1() {
            return config.tradingKlines.includes(this.klineType)
        },
    },
    watch: {
        showTip(val) {
            if (!val) {
                document.querySelector('#app').removeEventListener('touchmove', this.forbiddenScroll, false)
                this.resetTitle()
                this.handleTip({ show: val })
            } else {
                document.querySelector('#app').addEventListener('touchmove', this.forbiddenScroll, false)
            }
        }
    },
    created() {
        this.region = 'CN' //沪深板块
        this.initRegion()
    },
    mounted() {
        this.stock = {
            code: this.code,
            market: this.market
        }
        //this.handleWSListeners('on')
        this.initDataSet(this.klineType)
        this.initData()
        this.topChart = echarts.init(
            document.getElementById(`main-chart-top`)
        )
        this.bottomChart = echarts.init(
            document.getElementById(`main-chart-bottom`)
        )
    },
    beforeDestroy() {
        // this.handleKlineStack(0)
        // this.handleWSListeners('removeListener')
    },
    components: {
        MainChartTabs,
        MainChartIndicators,
        MainChartTips,
        MainChartSubTips,
    },
    methods: {
        initRegion() {
            this.klines = config.klines(this.region)
            this.MIN1Time = charts.tradingTime.create(this.region)
            this.regionConfig = config.region[this.region]
        },
        initDataSet(key) {
            this.dataSet[key] = {
                t: [],
                h: [],
                o: [],
                l: [],
                c: [],
                v: [],
                a: [],
                avg: [],
                totalAmount: 0,
                totalVol: 0
            }
            if (key !== 'MIN1' && !this.dataSet['MIN1']) {
                this.dataSet['MIN1'] = {
                    t: [],
                    h: [],
                    o: [],
                    l: [],
                    c: [],
                    v: [],
                    a: [],
                    avg: [],
                    totalAmount: 0,
                    totalVol: 0
                }
            }
        },
        async initData(st) {
            if (this.klineType === 'MIN1') {
                ws.websocket.safeSubscribeMINKL(this.plateBasicInfo.instrumentID, this.plateBasicInfo.exchangeID, this.klineType);
                ws.websocket.on('onMINKL', msg => {
                    if (msg.Inst === this.plateBasicInfo.instrumentID) {
                        this.cbKline(msg.QuoteData.KlineData, 'MIN1')
                    }
                });
            } else if (this.klineType === '5-MIN1') {
                this.getKlineByHttp(st)
            } else {
                this.getKlineByHttp(st)
            }
        },
        async getPlateTrend(dateOffset = 0) {
            const res = await getPlateTrendData({
                prodCode: this.prodCode,
                dateOffset
            })
            return res
        },
        async getPlateFiveTrendData() {
            const res = await getPlateFiveTrendData({
                prodCode: this.prodCode,
            })
            return res
        },

        async getPlateHistoryTrendData() {
            const i = {
                DAY: 6,
                WEEK: 7,
                MONTH: 8
            }
            const res = await getPlateHistoryTrendData({
                prodCode: this.prodCode,
                candlePeriod: i[this.klineType],
                candleMode: 0,
                startDate: 0,
                endDate: parseInt(new Date().getTime() / 1000),
            })
            return res
        },

        async getKlineByHttp(st) {
            let oldKlineType = this.oldKlineType = this.klineType
            if (this.pendingType[oldKlineType]) return
            this.pendingType[oldKlineType] = true
            const myKline = this.klines[oldKlineType]
            const params = {
                endtime: 2524579200,
                inst: this.plateBasicInfo.instrumentID,
                limit: -myKline.limit,
                market: this.plateBasicInfo.exchangeID,
                servicetype: 'KLINEB',
                starttime: st ? st + 1 : 0,
                resptype: 'JSON',
                period: myKline.period || oldKlineType
            }

            const res = await getKlineByHttp(params)
            delete this.pendingType[oldKlineType]
            if (!res
                || !res.KlineData) {
                return
            }
            if (config.minKlines.includes(this.klineType) && oldKlineType === this.klineType) {
                this.getKlineByWS(res.Period)
            }
            this.handleData(res.KlineData, oldKlineType)
        },
        // 今天的
        cbKline(data, klineType) {
            this.handleData(data, klineType)
        },

        handleData(data, klineType) {
            let vm = this
            klineType = klineType || vm.klineType
            let limit = this.klines['MIN1'].limit
            let is5day = klineType === '5-MIN1' && data.length > limit
            let isMin1 = klineType === 'MIN1'
            let min1Len = this.dataSet['MIN1'].c.length
            let { h, o, l, c, t, v, a, avg, totalAmount, totalVol } = this.dataSet[klineType]
            if (last(t) === last(data).Time) {
                // 防止分钟k线重复
                if (!isMin1) return this.renderCandleChart()
                h.pop()
                o.pop()
                l.pop()
                c.pop()
                t.pop()
                avg.pop()
                totalVol = totalVol - v.pop()
                totalAmount = totalAmount - a.pop()
            }
            if (klineType === 'DAY' && data.length) {
                let today = charts.getTodayData(this.dataSet.MIN1, last(data))
                today && data.push(today)
            }
            data.forEach((el, index) => {
                if (is5day && index % limit === 0) {
                    totalAmount = 0
                    totalVol = 0
                    t.push(el.Time + 1)
                    h.push('-')
                    o.push('-')
                    l.push('-')
                    c.push('-')
                    v.push('-')
                    a.push('-')
                    avg.push('-')
                }
                totalAmount += el.Amount
                totalVol += el.Volume
                t.push(el.Time)
                h.push(el.High)
                o.push(el.Open)
                l.push(el.Low)
                c.push(el.Close)
                v.push(el.Volume)
                a.push(el.Amount)
                avg.push(charts.formatUnit(totalAmount / totalVol, 0, true, this.regionConfig.precision))
            })
            this.dataSet[klineType].totalAmount = totalAmount
            this.dataSet[klineType].totalVol = totalVol
            this.klineDataInit = true
            if (klineType === 'DAY' && this.realKlineType) {
                this.klineType = this.realKlineType
                this.realKlineType = null
            }

            if (vm.klineType === 'MIN1') return this.renderMIN1Chart()
            // 特殊的k线，可能需要借用MIN1作为今日数据
            if ((vm.klineType === '1-MIN1' || vm.klineType === '5-MIN1') && klineType !== 'MIN1') return this.borrowMIN1(klineType === 'MIN1', min1Len)
            if (klineType !== 'MIN1' && this.oldKlineType === this.klineType) return this.renderCandleChart()
        },
        borrowMIN1(isTick, len) {
            const vm = this
            let limit = this.klines['MIN1'].limit
            let dataSet = this.dataSet
            let debtor = dataSet[vm.klineType]
            let debtee = dataSet['MIN1']
            // 5日数据真空期
            if (!debtor.t.length && isTick) return
            const next = vm.klineType === '5-MIN1' ? this.renderMIN1Chart : this.renderCandleChart
            if (last(debtor.t) === last(debtee.t) || !debtee.c.length) return next()
            // 5日需要切除第一天数据
            if (!isTick && vm.klineType === '5-MIN1' && debtor.t.length > 4 * limit) {
                debtor.t.splice(0, limit)
                debtor.h.splice(0, limit)
                debtor.o.splice(0, limit)
                debtor.l.splice(0, limit)
                debtor.c.splice(0, limit)
                debtor.v.splice(0, limit)
                debtor.a.splice(0, limit)
                debtor.avg.splice(0, limit)
            }
            if (isTick) {
                debtor.t.splice(-len)
                debtor.h.splice(-len)
                debtor.o.splice(-len)
                debtor.l.splice(-len)
                debtor.c.splice(-len)
                debtor.v.splice(-len)
                debtor.a.splice(-len)
                debtor.avg.splice(-len)
            }
            dataSet[vm.klineType] = {
                t: debtor.t.concat(debtee.t),
                h: debtor.h.concat(debtee.h),
                o: debtor.o.concat(debtee.o),
                l: debtor.l.concat(debtee.l),
                c: debtor.c.concat(debtee.c),
                v: debtor.v.concat(debtee.v),
                a: debtor.a.concat(debtee.a),
                avg: debtor.avg.concat(debtee.avg),
                totalAmount: debtee.totalAmount,
                totalVol: debtee.totalVol
            };
            (this.klineType !== 'MIN1' || this.oldKlineType === this.klineType) && next()
        },
        renderMIN1Chart() {
            if (!this.isLikeMin1) return
            this.topChart.setOption(charts.MIN1Chart.options(this), true)
            this.renderBottomChart()
        },
        renderCandleChart() {
            if (this.isLikeMin1
                || charts.candle.options(this) === -1) return
            this.topChart.setOption(this.candleOption, true)
            this.renderBottomChart()
        },
        renderBottomChart() {
            charts.bottom.options(this)
            this.bottomChart.setOption(this.bottomOption, true)
            !this.init && this.decorateCharts()
        },
        resetTitle() {
            this.titleData = []
            this.subTitleData = []
            this.bottomTitleData = []
            this.topChart.dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: 'leave'
            })
            this.bottomChart.dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: 'leave'
            })
        },
        createTitleData(index, val) {
            let { singleHand, precision } = this.regionConfig
            try {
                const { h, o, l, c, t, avg, v } = this.getMyData()
                let vol = unitUtils.formatUnit(v[index] / singleHand, false, true, 0)
                if (this.isLikeMin1) {
                    let base = this.statistic.PreClosePrice
                    let className = charts.getColorClass(c[index], base)
                    this.titleData = [
                        { title: '', value: charts.dateFormat(t[index] * 1000, 'hh:mm') },
                        { title: '价', value: c[index].toFixed(precision), className },
                        { title: '幅', value: `${(((c[index] - base) / base) * 100).toFixed(2)}%`, className },
                        { title: '量', value: vol },
                    ]
                    // !this.isIndex
                    // && this.titleData.push(
                    //   {title: '均', value: avg[index], className: charts.getColorClass(avg[index], base)}
                    // )
                } else {
                    let base = c[index - 1] || c[index]
                    this.titleData = [
                        { title: '开', value: o[index].toFixed(precision), className: charts.getColorClass(o[index], base) },
                        { title: '高', value: h[index].toFixed(precision), className: charts.getColorClass(h[index], base) },
                        { title: '幅', value: `${(((c[index] - base) / base) * 100).toFixed(2)}%`, className: charts.getColorClass(c[index], base) },
                        { title: '成交', value: vol },
                        { title: '收', value: c[index].toFixed(precision), className: charts.getColorClass(c[index], base) },
                        { title: '低', value: l[index].toFixed(precision), className: charts.getColorClass(l[index], base) },
                        { title: '额', value: `${((c[index] - base)).toFixed(precision)}`, className: charts.getColorClass(c[index], base) },
                    ]
                }
                !this.isLikeMin1 && this.createSubTitleData(val)
                    ; (this.techType !== 'v' || this.techType !== 'BOLL')
                        && this.createBottomTitle(index)
            } catch (e) {
                console.log(e)
            }
        },
        createSubTitleData(val) {
            this.subTitleData = charts.isDef(val)
                ? val.slice(1).map(item => {
                    return {
                        title: item.seriesName,
                        color: item.color,
                        className: 'rise-color',
                        value: item.value ? item.value.toFixed(this.regionConfig.precision) : '-'
                    }
                })
                : []
        },
        createBottomTitle(index) {
            this.bottomTitleData = charts.isDef(this.bottomRawData) && charts.isDef(index)
                ? this.bottomRawData.map(item => {
                    return {
                        title: item.name,
                        value: unitUtils.formatUnit(item.data[index]),
                        color: item.color
                    }
                })
                : []
        },
        getMyData() {
            return this.dataSet[this.klineType]
        },
        decorateCharts() {
            this.init = true
            this.oldAxisLabelDistance = 0
            this.topChart.on('datazoom', obj => {
                if (this.isLikeMin1) return
                const { start, end } = obj.batch[0]
                let newAxisLabelDistance = end - start
                const myData = this.getMyData()
                if (this.oldAxisLabelDistance !== newAxisLabelDistance) {
                    this.oldAxisLabelDistance = newAxisLabelDistance
                    this.topChart.setOption({
                        xAxis: {
                            axisLabel: {
                                interval: parseInt((newAxisLabelDistance) / 250 * myData.t.length)
                            }
                        }
                    })
                }
                this.bottomChart.dispatchAction({
                    type: 'dataZoom',
                    batch: [{
                        start,
                        end
                    }]
                })
            })
            charts.connectCharts([this.topChart, this.bottomChart])
        },
        cacheUsable(type) {
            return this.dataSet[type] && this.dataSet[type].t.length > 0
        },
        tabMutated(val) {
            if (this.klineType === val) return
            this.$nextTick(() => {
                this.topChart.resize()
                this.bottomChart.resize()
            })
            this.showTip = false
            const useCache = this.cacheUsable(val)
            // !useCache && this.initDataSet(val)
            this.klineDataInit = useCache
            this.klineType = val
            if (useCache) {
                this.isLikeMin1 ? this.renderMIN1Chart() : this.renderCandleChart()
            } else {
                this.initDataSet(val)
                this.initData()
            }
        },
        indicatorMutated(val) {
            // BOLL is belongs to top chart
            let renderCandle = this.techType === 'BOLL' || val === 'BOLL'
            this.techType = val
            renderCandle && this.renderCandleChart()
            this.renderBottomChart()
        },
        handleTip({ peer = 'topChart', show, x, y, isMoving }) {
            // throttle is useable
            // console.log(x && x.toFixed(1), y && y.toFixed(1))
            show && this[peer].dispatchAction({ type: `showTip`, x, y })
            !this.isLikeMin1 && !isMoving && this[peer].setOption({
                dataZoom: {
                    disabled: show
                }
            })
        },
        forbiddenScroll(e) {
            e.preventDefault()
        },
        touchStart(e, peer) {
            this.showTip = false
            this.removeIfTimer()
            this.timer = setTimeout(() => {
                this.showTip = true
                this.handleTip({ show: true, peer, x: e.zrX, y: e.zrY })
            }, 300)
        },
        touchMove(e, peer) {
            if (!this.showTip) return this.touchEnd()
            this.handleTip({ show: true, peer, x: e.zrX, y: e.zrY, isMoving: true })
        },
        touchEnd() {
            this.removeIfTimer()
            this.timer = this.showTip ? setTimeout(() => {
                this.showTip = false
            }, 5000) : null
        },
        removeIfTimer() {
            this.timer && clearTimeout(this.timer)
        }
    }
}
</script>

<style lang="stylus" scoped>
.chart-wrapper
    margin-top 0.06rem
    height 3.65rem
    position relative

.top-title
    position absolute
    top 0
    z-index 11
    height 0.39rem
    background-color #FAFAFA
    width 100%

.sub-title
    height 0.14rem

.bottom-title
    position absolute
    right 0

.chart-section
    display flex
    height 3.25rem
    background-color white
    padding 0 0.05rem

    .left
        margin 0.05rem 0
        width 2.6rem
        border 1px solid #f5f5f5
        position relative

        .icon
            height 0.17rem
            width 0.8rem
            position absolute
            left 0.9rem

    .left-full
        width 3.65rem

        .icon
            top 0.1rem
            left 1.42rem !important

    .right
        width 1.05rem

.main-chart-top
    width 100%
    height 2.55rem

.main-chart-bottom
    width 100%
    height 0.55rem

.top-full
    height 2.14rem

.bottom-full
    height 0.68rem

.indicators
    height 0.24rem
</style>